<div class="d-flex flex-column align-items-center justify-content-center h-100 w-100" role="status">
  <div *ngIf="authenticating">Logger ind...</div>
  <div *ngIf="errorMessage" class="text-center" role="alert">
    <p>{{ errorMessage }}</p>
    <button type="button" class="btn btn-primary" (click)="retryLogin()">Prøv igen</button>
  </div>
</div>
